import { genStyleHooks } from '../../theme/internal';
import type { AliasToken, GenerateStyle } from '../../theme/internal';
import { gray } from '../../theme/themes/colorPalette';

// biome-ignore lint/suspicious/noEmptyInterface: ComponentToken need to be empty by default
export interface ComponentToken {}

export interface ColorSelectToken extends AliasToken {
  componentCls: string;
}

const genColorSelectStyle: GenerateStyle<ColorSelectToken> = (token) => {
  const { componentCls } = token;
  return {
    [componentCls]: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 12,

      '&-swatch': {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 40,
        height: 40,
        padding: 0,
        borderRadius: 1000,
        border: `1px solid ${gray[100]}`,
        cursor: 'pointer',
        outline: 'none',
        transition: 'transform 0.12s ease, box-shadow 0.12s ease',

        '&:hover:not(:disabled)': {
          transform: 'scale(1.04)',
        },

        '&:focus-visible': {
          boxShadow: `0 0 0 2px ${gray[0]}, 0 0 0 4px ${gray[400]}`,
        },

        '&:disabled': {
          cursor: 'not-allowed',
          opacity: 0.6,
        },

        // Nested under the swatch (and targeting svg) to outrank the icon
        // font's `.youlifyicon { color: inherit }` base rule.
        [`${componentCls}-tick`]: {
          fontSize: 16,
          color: '#ffffff',
        },
      },

      '&-disabled': {
        cursor: 'not-allowed',
      },
    },
  };
};

export const useColorSelectStyle = genStyleHooks(
  'ColorSelect',
  (token) => [genColorSelectStyle(token)],
  undefined,
  { resetFont: false },
);
